<template>
  <span class="copy-id-btn" :title="copied ? 'Copied!' : 'Copy ID'" @click.stop="copyToClipboard">
    <i :class="copied ? 'fa fa-check text-success' : 'fa fa-copy'"></i>
  </span>
</template>

<script>
export default {
  name: 'CopyId',
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      copied: false,
    }
  },
  methods: {
    copyToClipboard() {
      navigator.clipboard.writeText(String(this.id)).then(() => {
        this.copied = true
        setTimeout(() => { this.copied = false }, 1500)
      })
    },
  },
}
</script>

<style scoped>
.copy-id-btn {
  cursor: pointer;
  margin-left: 4px;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}
.copy-id-btn:hover .b-icon {
  opacity: 0.75;
}
</style>
